import { AuthenticationHelper, CognitoUser } from 'amazon-cognito-identity-js'
/* eslint-disable-next-line no-restricted-modules */
const AWS = window.AWS || require('aws-sdk') // works in browser bundle
const apiLoader = AWS.apiLoader
const svc = 'cognitoidentityserviceprovider'

// ensure service registry exists
apiLoader.services[svc] = apiLoader.services[svc] || {}

// keep the existing getter if available
const originalGetter =
  Object.getOwnPropertyDescriptor(apiLoader.services[svc], '2016-04-18')?.get

Object.defineProperty(apiLoader.services[svc], '2016-04-18', {
  get () {
    // try to get the original model (already loaded in the bundle)
    let model = originalGetter ? originalGetter() : AWS.CognitoIdentityServiceProvider.api

    if (!model) {
      console.warn('Cognito model not found in browser context — using partial override only')
      model = { operations: {}, shapes: {} }
    }

    // clone to avoid side effects
    model = JSON.parse(JSON.stringify(model))

    // add the EmailMfaSettings shape
    model.shapes.EmailMfaSettingsType = {
      type: 'structure',
      members: {
        Enabled: { type: 'boolean' },
        PreferredMfa: { type: 'boolean' },
      },
    }

    // override AdminSetUserMFAPreference operation
    // Use minified shape names to match existing model style
    model.operations.AdminSetUserMFAPreference = {
      name: 'AdminSetUserMFAPreference',
      http: { method: 'POST', requestUri: '/' },
      input: {
        type: 'structure',
        required: ['UserPoolId', 'Username'],
        members: {
          UserPoolId: {},
          Username: { shape: 'Sd' },
          SMSMfaSettings: { shape: 'S31' },
          SoftwareTokenMfaSettings: { shape: 'S32' },
          EmailMfaSettings: { shape: 'EmailMfaSettingsType' },
        },
      },
      output: { type: 'structure', members: {} },
    }

    return model
  },
  enumerable: true,
  configurable: true,
})

/*
The version of the Cognito library we use is extremely outdated and does not suppoert Email OTP. We override
the function to support Email OTP challenges.
 */
CognitoUser.prototype.setUserMfaPreference = function setUserMfaPreference (emailMfaSettings, smsMfaSettings, softwareTokenMfaSettings, callback) {
  if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
    return callback(new Error('User is not authenticated'), null)
  }

  this.client.request('SetUserMFAPreference', {
    EmailMfaSettings: emailMfaSettings,
    SMSMfaSettings: smsMfaSettings,
    SoftwareTokenMfaSettings: softwareTokenMfaSettings,
    AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
  }, function (err) {
    if (err) {
      return callback(err, null)
    }
    return callback(null, 'SUCCESS')
  })
  return undefined
}

CognitoUser.prototype.authenticateUserInternal = function authenticateUserInternal (dataAuthenticate, authenticationHelper, callback) {
  var _this3 = this

  var challengeName = dataAuthenticate.ChallengeName
  var challengeParameters = dataAuthenticate.ChallengeParameters

  if (challengeName === 'SMS_MFA') {
    this.Session = dataAuthenticate.Session
    return callback.mfaRequired(challengeName, challengeParameters)
  }

  if (challengeName === 'EMAIL_OTP') {
    this.Session = dataAuthenticate.Session
    return callback.mfaRequired(challengeName, challengeParameters)
  }

  if (challengeName === 'SELECT_MFA_TYPE') {
    this.Session = dataAuthenticate.Session
    return callback.selectMFAType(challengeName, challengeParameters)
  }

  if (challengeName === 'MFA_SETUP') {
    this.Session = dataAuthenticate.Session
    return callback.mfaSetup(challengeName, challengeParameters)
  }

  if (challengeName === 'SOFTWARE_TOKEN_MFA') {
    this.Session = dataAuthenticate.Session
    return callback.totpRequired(challengeName, challengeParameters)
  }

  if (challengeName === 'CUSTOM_CHALLENGE') {
    this.Session = dataAuthenticate.Session
    return callback.customChallenge(challengeParameters)
  }

  if (challengeName === 'NEW_PASSWORD_REQUIRED') {
    this.Session = dataAuthenticate.Session

    var userAttributes = null
    var rawRequiredAttributes = null
    var requiredAttributes = []
    var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix()

    if (challengeParameters) {
      userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes)
      rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes)
    }

    if (rawRequiredAttributes) {
      for (var i = 0; i < rawRequiredAttributes.length; i++) {
        requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length)
      }
    }
    return callback.newPasswordRequired(userAttributes, requiredAttributes)
  }

  if (challengeName === 'DEVICE_SRP_AUTH') {
    this.getDeviceResponse(callback)
    return undefined
  }

  this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult)
  this.cacheTokens()

  var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata
  if (newDeviceMetadata == null) {
    return callback.onSuccess(this.signInUserSession)
  }

  authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
    if (errGenHash) {
      return callback.onFailure(errGenHash)
    }
    var _global = require('aws-sdk/global')

    var deviceSecretVerifierConfig = {
      Salt: new _global.util.Buffer(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
      PasswordVerifier: new _global.util.Buffer(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
    }

    _this3.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier
    _this3.deviceGroupKey = newDeviceMetadata.DeviceGroupKey
    _this3.randomPassword = authenticationHelper.getRandomPassword()

    _this3.client.request('ConfirmDevice', {
      DeviceKey: newDeviceMetadata.DeviceKey,
      AccessToken: _this3.signInUserSession.getAccessToken().getJwtToken(),
      DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
      DeviceName: navigator.userAgent
    }, function (errConfirm, dataConfirm) {
      if (errConfirm) {
        return callback.onFailure(errConfirm)
      }

      _this3.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey
      _this3.cacheDeviceKeyAndPassword()
      if (dataConfirm.UserConfirmationNecessary === true) {
        return callback.onSuccess(_this3.signInUserSession, dataConfirm.UserConfirmationNecessary)
      }
      return callback.onSuccess(_this3.signInUserSession)
    })
    return undefined
  })
  return undefined
}

CognitoUser.prototype.sendMFACode = function sendMFACode (confirmationCode, callback, mfaType) {
  var _this7 = this

  var challengeResponses = {}
  challengeResponses.USERNAME = this.username
  var mfaTypeSelection = mfaType || 'SMS_MFA'
  if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') {
    challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode
  } else if (mfaTypeSelection === 'EMAIL_OTP') {
    challengeResponses.EMAIL_OTP_CODE = confirmationCode
  } else if (mfaTypeSelection === 'SMS_MFA') {
    challengeResponses.SMS_MFA_CODE = confirmationCode
  }

  if (this.deviceKey != null) {
    challengeResponses.DEVICE_KEY = this.deviceKey
  }

  var jsonReq = {
    ChallengeName: mfaTypeSelection,
    ChallengeResponses: challengeResponses,
    ClientId: this.pool.getClientId(),
    Session: this.Session
  }
  if (this.getUserContextData()) {
    jsonReq.UserContextData = this.getUserContextData()
  }

  this.client.request('RespondToAuthChallenge', jsonReq, function (err, dataAuthenticate) {
    if (err) {
      return callback.onFailure(err)
    }

    var challengeName = dataAuthenticate.ChallengeName

    if (challengeName === 'DEVICE_SRP_AUTH') {
      _this7.getDeviceResponse(callback)
      return undefined
    }

    _this7.signInUserSession = _this7.getCognitoUserSession(dataAuthenticate.AuthenticationResult)
    _this7.cacheTokens()

    if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
      return callback.onSuccess(_this7.signInUserSession)
    }

    var authenticationHelper = new AuthenticationHelper(_this7.pool.getUserPoolId().split('_')[1])
    authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
      if (errGenHash) {
        return callback.onFailure(errGenHash)
      }

      var _global = require('aws-sdk/global')

      var deviceSecretVerifierConfig = {
        Salt: new _global.util.Buffer(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
        PasswordVerifier: new _global.util.Buffer(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
      }

      _this7.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier
      _this7.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey
      _this7.randomPassword = authenticationHelper.getRandomPassword()

      _this7.client.request('ConfirmDevice', {
        DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
        AccessToken: _this7.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
        DeviceName: navigator.userAgent
      }, function (errConfirm, dataConfirm) {
        if (errConfirm) {
          return callback.onFailure(errConfirm)
        }

        _this7.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey
        _this7.cacheDeviceKeyAndPassword()
        if (dataConfirm.UserConfirmationNecessary === true) {
          return callback.onSuccess(_this7.signInUserSession, dataConfirm.UserConfirmationNecessary)
        }
        return callback.onSuccess(_this7.signInUserSession)
      })
      return undefined
    })
    return undefined
  })
}
